import { useCallback, useState } from 'react';
import MasterComponentWraper from '../../Backend/MasterComponentWraper';
import NavigationHeder from '../../Navigations/NavigationHeder';
import ButtonNew from '../../inc/ButtonNew';
import AgGridNew from '../../grid/ag/ag-grid-new';
import Api from '../../../inc/Api';
import { useNavigate } from 'react-router-dom';
import Settings from '../../../inc/Settings';
import { getPopupMessageBasedOnStatus } from '../../../inc/Validation';
import Helper from '../../../inc/Helper';
import { getLabelFromDropdown, gridLinkValueFormat } from '../../grid/ag/commonFunctions/GridCommonFunctions';
import DatepickerFunctions from '../../../inc/DatepickerHelper';
import SimpleDropdown from '../../grid/ag/cellEditor/SimpleDropdown';
import ApiManagerPopup from './ApiManagerPopup';

let gridApi = null;
const ApiManagerListings = () => {
  const [openPopupView, setOpenPopupView] = useState(false);

  const navigate = useNavigate();

  const onClickRedirectToDetailView = (event) => {   
    if(event.colDef.field === 'api_url') { 
      navigate(`/edit-api-manager-form/${event?.data?.id}`)
    }
  };

  const onClickPopupView = () => {
    setOpenPopupView(true);
  };

  const onDeleteIntegrationDocument = useCallback(async (element) => { 
    let api = Api;
    api.setUserToken();
    
    let delDocument_ID = element?.data?.id;

    try {
      const res = await api
      .axios()
      .delete(Settings.apiAppUrl+`/api-manager/delete/${delDocument_ID}`)

      const rowNode = gridApi?.getRowNode(delDocument_ID)
      
      if (rowNode) {
        rowNode.setSelected(false)
      }
      
      setTimeout(() => {
        const transaction = { remove: [element.data] }
        gridApi?.applyServerSideTransaction(transaction) 
      }, 200);

      gridApi?.refreshServerSide({ purge: true })
      gridApi?.deselectAll();
      
      Helper.alert(res?.data?.message || 'Api manager deleted successfully', 'success')
    } catch (err) {
      getPopupMessageBasedOnStatus(err)
    }
  }, []);

  const reloadParentGrid = () => {
    gridApi?.refreshServerSide({ purge: true });
    gridApi?.deselectAll();
  };

  const gridColumnHeaders = [
    {field:'api_url', minWidth:240, headerName:'Api url', cellRenderer: (params) => gridLinkValueFormat(params), editable: false }, 
    {
      field: 'api_name',
      headerName: 'Api name',
      editable: false, 
      isAllowZero:true,
      cellEditor: SimpleDropdown,
      minWidth:240,  
      cellEditorParams: {
        values: Settings.apiNamesEnum
      },
      cellDataType:false,
      valueFormatter: (params) => getLabelFromDropdown(params)
    },
    {
      field: 'api_method',
      headerName: 'Api method',
      editable: false, 
      isAllowZero:true,
      cellEditor: SimpleDropdown,
      minWidth:240,  
      cellEditorParams: {
        values: Settings.httpMethodOptions
      },
      cellDataType:false,
      valueFormatter: (params) => getLabelFromDropdown(params, true)
    },
    {field:'timeout', minWidth:240, headerName:'Timeout', editable: false },
    {field:'retry_count', minWidth:240, headerName:'Retry count', editable: false },
    {field:'priority', minWidth:240, headerName:'Priority', editable: false },
    {field:'body', minWidth:240, headerName:'Body', editable: false },
    {field:'sample_payload', minWidth:240, headerName:'Sample payload', editable: false }, 
    {field:'app_name', minWidth:240, headerName:'App', editable: false },
    {
      field:'is_asynchronous', 
      editable: false, headerName: 'is Asynchronous', minWidth:240,
      cellRenderer: 'agCheckboxCellRenderer',
      cellRendererParams: { disabled: true },
      valueGetter: (params) => {
        if(!params?.data?.is_asynchronous || !params?.data){
          return false
        }
        else {
          return params.data?.is_asynchronous
        }
      }
    },
    {
      field: 'status',
      headerName: 'Status',
      minWidth:240,
      editable: false, 
      isAllowZero:true,
      cellEditor: SimpleDropdown,
      minWidth:240,  
      cellEditorParams: {
        values: Settings.enumStatus
      },
      cellDataType:false,
      valueFormatter: (params) => getLabelFromDropdown(params)
    },
    {field:'created_by', minWidth:240, headerName:'Created by', editable: false },
    {field:'created_datetime', minWidth:240, valueFormatter: (params) => params?.value ? DatepickerFunctions.convertDateTimeFromDataBase(params?.value) : '-', headerName:'Created date time', editable: false },
    {field:'modified_by', minWidth:240, headerName:'Modified by', editable: false },
    {field:'modified_datetime', minWidth:240, valueFormatter: (params) => params?.value ? DatepickerFunctions.convertDateTimeFromDataBase(params?.value) : '-', headerName:'Modified date time', editable: false },
  ];

  return (
    <div className='container-fluid'>
      <NavigationHeder hideMoreBtn={true} backUrl='/system-integration' title={'API Manager'}>
        <ButtonNew onClick={onClickPopupView} title={'New'}  />
      </NavigationHeder>

      <AgGridNew
        apiUrl={Settings.apiAppUrl+'/api-manager'} 
        pagination={true}
        columnDefs={gridColumnHeaders}
        hideAddBtn={true}
        paginationPageSize={100}
        height={500}
        uniqueField={'id'}
        onCellClicked={onClickRedirectToDetailView}
        handleDeleteSelectedRows={onDeleteIntegrationDocument}
        onGridReady={(params) => gridApi = params?.api} 
        gridId={"api_manager_listing_grid"}
      />

      {openPopupView && <ApiManagerPopup reloadParentGrid={reloadParentGrid} setClosePopupViewModal={setOpenPopupView} />}
    </div>
  );
};

export default (MasterComponentWraper(ApiManagerListings));